const STATUS = {
  ready: {
    channel: false,
    campaign: true
  },
  publishQueued: {
    channel: true,
    campaign: true
  },
  published: {
    channel: true,
    campaign: true
  },
  publishDeferred: {
    channel: true,
    campaign: true
  },
  publishFailed: {
    channel: false,
    campaign: true
  },
  removalQueued: {
    channel: false,
    campaign: true
  },
  removed: {
    channel: false,
    campaign: false
  },
  removalDeferred: {
    channel: false,
    campaign: false
  },
  removalFailed: {
    channel: false,
    campaign: false
  }
}

const BOARD_TYPES_WITH_SUB_TYPE = {
  facebookProfile: 'facebookPage',
  pinterestProfile: 'pinterestBoard'
}

const CALENDAR_VIEWS = {
  month: true,
  agendaWeek: true
}

const SHOP_TYPES = {
  shopamineShop: true,
  wooCommerceShop: true,
  shopifyShop: true
}

const DISCOUNT_MPE_TYPES = {
  shopifyDiscount: true,
  shopamineDiscount: true,
  woocommerceDiscount: true
}

const ROLES = {
  admin: '99999999-9999-9999-9999-999999999999',
  v2subscriber: '00000000-0000-0000-0001-200000000000'
}

const INVALID_PASSWORD = 'apinput.mutation.user.OldPasswordInvalid'

const ERROR_NOTIFICATION_BASE = 'Notification.error.'

const EMAIL_NOT_VALIDATED = 'AuthEmailNotValidated'

const USER_EMAIL_NOT_VALIDATED = 'AuthUserEmailNotValidated'

  /**
   * Receives the channel type and determines what is the media field name
   * @param {String} channelType Channel type we have.
   * @returns {String} Channel media field nae or 'unknownType' if type is unknown.
   */
const getMediaFieldName = function (channelType) {
  switch (channelType) {
    case 'facebookPost':
      return 'photos'

    case 'twitterTweet':
      return 'media'

    case 'sqwizArticle':
      return 'images'

    case 'sqwizProduct':
      return 'images'

    case 'shopamineProduct':
      return 'images'

    case 'shopaminePost':
      return 'images'

    case 'informacijaProduct':
      return 'images'

    case 'informacijaPost':
      return 'images'

    case 'pinterestPin':
      return 'image'

    case 'wordpressPost':
      return 'media'

    case 'woocommerceProduct':
      return 'images'
  }

  return 'unknownType'
}

/**
 * Tells if given channel's mpes have a label on campaign preview
 * @param {String} channelType
 * @returns {Boolean}
 */
const channelHasLabel = function (channelType) {
  return !!({
    'sqwizPage': true,
    'informacijaShop': true,
    'shopamineShop': true
  })[channelType]
}

/**
 * Receives the response's error code and returns a i18 error code
 * @param {String} oErrString Original error code string from API.
 * @returns {String|undefined} i18 error code OR original error if format is invalid OR undefined if invalid data type
 */
const resolve = function (oErrString) {
  if (!oErrString || typeof oErrString !== 'string') return

  let errString = extractErrorString(oErrString)
  if (!errString) return oErrString

  let splitErrString = errString.split('.')
  if (splitErrString.length < 2) return errString

  // First obtain the last element (the code) then the type (2nd. to last)
  let errCode = splitErrString.pop()
  let errType = splitErrString.pop()
  return `${ERROR_NOTIFICATION_BASE}${errType}.${errCode}`
}

const isEmailValidated = function (errorMessage = '') {
  let message = extractErrorString(errorMessage).split('.').pop()
  return message === EMAIL_NOT_VALIDATED || message === USER_EMAIL_NOT_VALIDATED
}

const isDiscountMpe = function (type) {
  return !!DISCOUNT_MPE_TYPES[type]
}

/**
 * Determines wether the given type is a campaign or not
 * @param {String} type Object's type
 */
const isCampaign = function (type) {
  let campaignTypes = {
    productPromotion: true,
    dailyDeal: true,
    sale: true
  }

  return !!campaignTypes[type]
}

export { getMediaFieldName, channelHasLabel, resolve, ERROR_NOTIFICATION_BASE, isEmailValidated, EMAIL_NOT_VALIDATED, USER_EMAIL_NOT_VALIDATED, isDiscountMpe, DISCOUNT_MPE_TYPES, isCampaign }

export default {
  /**
   * Tells if given error is for wrong old password
   * @param {String} errCode
   * @returns {String|Boolean}
   */
  isOldPasswordWrong (errCode) {
    if (extractErrorString(errCode) === INVALID_PASSWORD) {
      return this.resolve(errCode)
    }
    return false
  },

  getMediaFieldName,
  channelHasLabel,
  resolve,
  isEmailValidated,
  isCampaign,

  /**
   * Determines wether the given view is a calendar view or not
   * @param {String} view Current view
   * @returns {Boolean} If this view is a calendar view
   */
  isCalendarView (view) {
    return !!(CALENDAR_VIEWS[view])
  },

  /**
   * Tells the size of date step for specific views
   * @param {String} view View we are interested in
   * @returns {String}
   */
  getDateStepSize (view) {
    switch (view) {
      case 'month':
        return view

      case 'agendaWeek':
        return 'week'

      case 'week':
        return view

      default:
        return 'day'
    }
  },

  /**
   * Tells what places that MPE can be removed from
   * @param {String} status MPE's status
   */
  whereToRemoveFrom (status) {
    return STATUS[status] || {}
  },

  /**
   * Tells if given type is a shop or not
   * @param {String} type Checked type
   */
  isShop (type) {
    return !!SHOP_TYPES[type]
  },

  /**
   * Tells if given credential type has any sub types, such as a fb profile > fb page
   * @param {String} type Possible parent type
   * @returns {[String|undefined]}
   */
  hasSubChannels (type) {
    return BOARD_TYPES_WITH_SUB_TYPE[type]
  },

  /**
   * Tells if given credential type is a sub type, such as a fb page
   * @param {String} type
   * @returns {Boolean}
   */
  isSubChannel (type) {
    return Object.values(BOARD_TYPES_WITH_SUB_TYPE).indexOf(type) > -1
  },

  /**
   * Tells if given user is a super user
   * @param {Array} roles Array of user's roles
   * @returns {Boolean}
   */
  isSuperUser (roles = []) {
    return !!roles.filter(r => r.id === ROLES.admin).length
  }
}

/**
 * Tells if given user is a v2subscriber
 * @param {Array} roles Array of user's roles
 * @returns {Boolean}
 */
const isV2Subscriber = function (roles = []) {
  return !!getV2Subscriber(roles)
}

/**
 * Gets v2subscriber role
 * @param {Array} roles Array of user's roles
 * @returns {Object}
 */
const getV2Subscriber = function (roles = []) {
  return roles.filter(r => r.id === ROLES.v2subscriber)[0]
}

export { isV2Subscriber, getV2Subscriber }

const roles = {
  /**
   * Gives roleID for given role
   * @param {String} role
   * @returns {String|undefined}
   */
  getRoleId (role) {
    return { id: ROLES[role] }
  }
}

export { roles as roles }

/**
 * Extracts err code from entire error string
 * @param {String} errCode
 * @returns {String}
 */
function extractErrorString (errCode) {
  if (errCode.indexOf(':') > -1) {
    errCode = errCode.split(':')[1]
  }
  return errCode.trim()
}



// WEBPACK FOOTER //
// ./src/assets/modules/error/resolver.js